import { render, staticRenderFns } from "./bSpecialCategoryView.vue?vue&type=template&id=686da6af&scoped=true"
import script from "./bSpecialCategoryView.vue?vue&type=script&lang=js"
export * from "./bSpecialCategoryView.vue?vue&type=script&lang=js"
import style0 from "./bSpecialCategoryView.vue?vue&type=style&index=0&id=686da6af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686da6af",
  null
  
)

export default component.exports